/**
 * Given an object representing the form values, it returns an array with the inputs error messages.
 *
 * @example ['First name error', 'Last name error', 'email error', 'Role error']
 * @param {Object} formValues - An object with the form values.
 * @returns {Array} An array with the inputs error messages with the shape [firstNameError, lastNameError, emailError, roleError].
 */
export const getInputErrorMessages = (formValues) => {
  const firstNameError =
    formValues.firstName.touched && formValues.firstName.value.length === 0
      ? formValues.firstName.errorMessage
      : "";
  const lastNameError =
    formValues.lastName.touched && formValues.lastName.value.length === 0
      ? formValues.lastName.errorMessage
      : "";
  const emailError =
    formValues.email.touched && formValues.email.value.length === 0
      ? formValues.email.errorMessage
      : "";
  const roleError =
    formValues.role.touched && formValues.role.value.length === 0
      ? formValues.role.errorMessage
      : "";
  return [firstNameError, lastNameError, emailError, roleError];
};
